var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 17,
    viewBox: "0 0 12 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 2.5C4.22386 2.5 4 2.72386 4 3C4 3.27614 4.22386 3.5 4.5 3.5H7.5C7.77614 3.5 8 3.27614 8 3C8 2.72386 7.77614 2.5 7.5 2.5H4.5Z",
    fill: "#BCBDBF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 8.5C9 10.1569 7.65685 11.5 6 11.5C4.34315 11.5 3 10.1569 3 8.5C3 6.84315 4.34315 5.5 6 5.5C7.65685 5.5 9 6.84315 9 8.5Z",
    fill: "#BCBDBF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 0.5C1.11929 0.5 0 1.61929 0 3V14.5C0 15.6046 0.895431 16.5 2 16.5H10C11.1046 16.5 12 15.6046 12 14.5V3C12 1.61929 10.8807 0.5 9.5 0.5H2.5ZM1 3C1 2.17157 1.67157 1.5 2.5 1.5H9.5C10.3284 1.5 11 2.17157 11 3V13.795C10.8152 13.6446 10.5619 13.4719 10.2236 13.3028C9.39204 12.887 8.0628 12.5 6 12.5C3.9372 12.5 2.60796 12.887 1.77639 13.3028C1.43811 13.4719 1.18477 13.6446 1 13.795V3Z",
    fill: "#BCBDBF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/Union.c52f27d2b9dfa05cb6b6039014062632.svg";
export { ForwardRef as ReactComponent };